export const TRUE = 'TRUE'
export const FALSE = 'FALSE'
export const YES = 'YES'
export const NO = 'NO'
export const ONE = '1'
export const ZERO = '0'
export const Y = 'Y'
export const N = 'N'
export const TRUE_LOWERCASE = 'true'
export const FALSE_LOWERCASE = 'false'
export const POSITIVE_VALUES = [TRUE, 'True', Y, 'Yes', YES, TRUE_LOWERCASE]
export const NEGATIVE_VALUES = [FALSE, 'False', N, 'No', NO, FALSE_LOWERCASE]
